import styled from 'styled-components'

export const Container = styled.div`
  padding-bottom: 60px;
  width: 100%;
  display: block;

  .DFGreyBox,
  .loader-wrapper {
    width: 100% !important;
  }

  .DFtitleUpload {
    display: none;
  }
`

export const ContainerDefault = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
`

export const ContainerActionUpdate = styled.div`
  width: 100%;
  max-width: 600px;
  margin: auto;
  display: flex;
  justify-content: end;

  button {
    margin: 15px 5px 5px 0px;
  }
`

export const ActionsContainer = styled.div`
  margin-bottom: 60px;

  .button-group {
    width: 100%;
    padding-top: 24px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 16px;

    button {
      margin: 0;
      max-width: 100%;
    }
  }
`
